var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{ref:"target",staticClass:"animation-killswitch",attrs:{"aria-label":_vm.ariaLabel},on:{"click":_vm.onClick}},[(_vm.animStore.hasAnimation)?_vm._t("animation"):_vm._e(),(!_vm.animStore.hasAnimation)?_vm._t("no-animation"):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }